export default {"src":"/_next/static/media/audit-and-reporting.53766041.svg","height":854,"width":640,"blurWidth":0,"blurHeight":0};